import React from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading, PersianDataPicker, RadioButton, TextArea} from 'components/form';
import {required, validationWrapper, isUserName} from 'lib/formValidations';
import {
   transformTranslateFromValues,
   transformTranslateServerValues,
   toDatePicker,
   dateTimeToserver
} from 'lib/helpers';
import Modal from 'components/Modal';

// components

export default function Edit(props) {

   const {show, item} = props
   return (
      <>
         <Modal show={props.show} handleClose={props.close} title={props.title}>
            <Formik
               initialValues={{...transformTranslateServerValues(item), expire_at: toDatePicker(item.expire_at)}}
               onSubmit={async (values, {setSubmitting}) => {
                  if (values.expire_at)
                     values.expire_at = dateTimeToserver(values.expire_at)
                  await props.submit(transformTranslateFromValues(values), item.id);
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >

               {({isSubmitting, dirty}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-2 md:gap-3">
                           <Field
                              placeholder="نام کاربری"
                              label="نام کاربری :"
                              name="user_name"
                              component={TextField}
                              validate={isUserName}
                           />
                           <div className="mt-3">
                              <label>وضعیت :</label>
                              <div className="flex flex-col sm:flex-row mt-2">
                                 <Field
                                    id="Disabled"
                                    title="غیرفعال"
                                    name="status"
                                    group="status"
                                    value="Disabled"
                                    component={RadioButton}
                                 />
                                 <Field
                                    id="Blocked"
                                    title="مسدود"
                                    name="status"
                                    group="status"
                                    value="Blocked"
                                    component={RadioButton}
                                 />
                              </div>
                           </div>
                           <Field
                              label="تاریخ انقضا :"
                              name="expire_at"
                              component={PersianDataPicker}
                              format="YYYY/MM/DD HH:mm:ss"
                              hasTime={true}
                           />
                           <Field
                              label="توضیحات"
                              name="reason"
                              component={TextArea}
                              validate={(value) => validationWrapper(value, required)}
                           />
                        </div>
                     </div>

                     <div className="modal-footer text-right">
                        <button className="btn btn-primary w-20" type="submit"
                                disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                           <Loading/> : 'ذخیره'}</button>
                        <button type="button"
                                disabled={isSubmitting}
                                onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
